import { Component, OnInit, Inject, PLATFORM_ID, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { InvoiceService } from '../../services/invoice.service';
import { ParameterService } from '../../services/parameter.service';
import { isPlatformServer } from '@angular/common';
import { Parameter } from '../../models/parameter';
import { TranslateService } from '@ngx-translate/core';
import { Chapter } from '../../models/chapter';

const ERROR_KEY = makeStateKey('errorMessage');
const PARAMETER_KEY = makeStateKey('parameter');
const CHAPTER_KEY = makeStateKey('chapter');

declare var document: any;

@Component({
  selector: 'app-search-invoice',
  templateUrl: './search-invoice.component.html',
  styleUrls: ['./search-invoice.component.css']
})
export class SearchInvoiceComponent implements OnInit, AfterViewInit {

  errorMessage: string;
  chamberId: string;
  isServer: boolean;

  invoiceId: string;
  accountId: string;
  selectedChapter: string;
  selectedReferenceType: string;
  loading: boolean;

  parameter: Parameter;
  chapters: Chapter[];

  @ViewChild('accountNumberInput') accountNumberInput: ElementRef;
  @ViewChild('invoiceNumberInput') invoiceNumberInput: ElementRef;
  @ViewChild('chapterSelect') chapterSelect: ElementRef;
  @ViewChild('referenceTypeSelect') referenceTypeSelect: ElementRef;

  constructor(
    private state: TransferState,
    private route: ActivatedRoute,
    private invoiceService: InvoiceService,
    private parameterService: ParameterService,
    private translateService: TranslateService,
    @Inject(PLATFORM_ID) platformId
  ) {
    this.isServer = isPlatformServer(platformId);
    this.route
      .queryParams
      .subscribe(params => {
        this.chamberId = params['chamber'];
      });
    this.route
      .queryParams
      .subscribe(params => {
        this.errorMessage = params['errMess'];
      });
    this.loading = false;
  }

  ngOnInit() {
    this.invoiceId = '';
    this.accountId = '';
    this.selectedChapter = null;
    this.selectedReferenceType = null;
    this.loading = false;
    this.parameterService.setParameter(this.state.get<Parameter>(PARAMETER_KEY, null));
    this.parameter = this.state.get<Parameter>(PARAMETER_KEY, null);
    this.chapters = this.state.get<Chapter[]>(CHAPTER_KEY, new Array());
    this.errorMessage = this.state.get<string>(ERROR_KEY, null);

    if (this.isServer) {
      this.parameterService.getParameterAPI(this.chamberId)
        .then((parameter) => {
          this.parameterService.setParameter(parameter);
          this.state.set<Parameter>(PARAMETER_KEY, parameter as Parameter);
          this.parameter = parameter;
          if (this.parameter.UseMembershipNotice) {
            this.selectedReferenceType = 'invoice';
          }
        })
        .catch(() => {
          this.errorMessage = 'Parameter not found';
          this.state.set<string>(ERROR_KEY, this.errorMessage);
        });

      this.parameterService.getChapterAPI(this.chamberId)
      .then((chapters) => {
        this.state.set<Chapter[]>(CHAPTER_KEY, chapters as Chapter[]);
        this.chapters = chapters;
        if (this.chapters && this.chapters.length > 0) {
          this.selectedChapter = this.chapters[0].Id;
        }
      })
      .catch(() => {
        this.errorMessage = 'Chapter not found';
        this.state.set<string>(ERROR_KEY, this.errorMessage);
      });
    }
  }

  ngAfterViewInit() {
    if (!this.isServer) {
      this.setInputFilter(document.getElementById('accountNumber'), function(value) {
        return /^\d*$/.test(value);
      }, 'Only digits are allowed');
    }
  }

  onSearch() {
    this.errorMessage = null;
    this.state.set<string>(ERROR_KEY, this.errorMessage);

    if (this.accountNumberInput.nativeElement.value !== this.accountId) {
      this.accountId = this.accountNumberInput.nativeElement.value;
      this.invoiceId = this.invoiceNumberInput.nativeElement.value;
      this.selectedChapter = this.chapterSelect.nativeElement.value;
      this.selectedReferenceType = this.referenceTypeSelect.nativeElement.value;
    }

    this.loading = true;
    this.invoiceService.findInvoice(this.chamberId, this.invoiceId, this.accountId, this.selectedChapter, this.selectedReferenceType)
    .then((url) => {
      if (!this.isServer) {
        window.location.href = url;
      }
    })
    .catch((error) => {
      this.errorMessage = this.translateService.instant('Search.NotFound');
      this.state.set<string>(ERROR_KEY, this.errorMessage);
      this.loading = false;
    });
  }

  setInputFilter(textbox: Element, inputFilter: (value: string) => boolean, errMsg: string): void {
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop', 'focusout'].forEach(function(event) {
        textbox.addEventListener(event, function(this: (HTMLInputElement | HTMLTextAreaElement) & {oldValue: string; oldSelectionStart: number | null, oldSelectionEnd: number | null}) {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (Object.prototype.hasOwnProperty.call(this, 'oldValue')) {
                this.value = this.oldValue;
                if (this.oldSelectionStart !== null &&
                    this.oldSelectionEnd !== null) {
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                }
            } else {
                this.value = '';
            }
        });
    });
  }

  closeError() {
    this.errorMessage = null;
    this.state.set<string>(ERROR_KEY, this.errorMessage);
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/search-invoice/search-invoice.component.ts